import {useContainerBreakpoint} from "@project/layouts";
import {routes} from "@project/router";
import {Navigate, createFileRoute} from "@tanstack/react-router";
import {useRef} from "react";

export const Route = createFileRoute("/_app/sales/offers/$offerId/")({
  component: IndexRouteComponent,
});

function IndexRouteComponent() {
  const {offerId} = Route.useParams();
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useContainerBreakpoint(ref);

  if (isDesktop) {
    return (
      <Navigate replace params={{offerId}} to={routes.sales.offers.offer().preview()} search={{}} />
    );
  }

  return <div ref={ref} className="h-full w-full" />;
}
